{{urlPath}}
<iframe [src]="urlPath | safe: 'resourceUrl' " width="100%" height="800px">
</iframe>
